import { SubstituteItemAreaAction } from '../substitute_item/substitute_item_area_action';
import { Analytics } from './analytics';
import { AnalyticsItem } from '../../models/analytics/analytics_item';

export class SubstituteItemAreaAnalytics extends Analytics {
  constructor() {
    super();
    SubstituteItemAreaAction.SEND_SUBSTITUTE_ITEM_AREA_EVENT.on((data) => {
      this.run(() => {
        const fName = this.getFName(data.linkName as string);
        const linkAnalyticsData = {
          server: 'club/pc',
          fName: fName,
          events: ['event276'],
          items: this.createItems(data.analyticsData.items),
          soloel: {
            server: 'soloel/pc',
            prop5: fName,
            events: ['event89'],
            products: this.createProducts(data.analyticsData.items)
          }
        };
        window.sc_trackLinkAll(linkAnalyticsData, data.target, 'o', data.linkName);
      });
    });
  }

  private createItems(items: AnalyticsItem[]) {
    return items.map((item) => {
      return {
        category: '',
        productName: item._substituteItemKey.getProductName(),
        quantity: '',
        price: '',
        events: ['event276=1'],
        evars: {
          substituteItemCode: item.getProductName(),
          substituteItemArea: item._viewAreaName
        }
      };
    });
  }

  private createProducts(items: AnalyticsItem[]) {
    return items.map((item) => {
      return {
        category: '',
        productName: item._substituteItemKey.getProductNameForSoloel(),
        quantity: '',
        price: '',
        events: ['event89=1'],
        evars: {
          eVar82: item.getProductNameForSoloel(),
          eVar83: item._viewAreaName
        }
      };
    });
  }

  private getFName(linkName: string): string {
    switch (linkName) {
      case 'DispReplacementAreaByCategory':
        return '代替品エリア表示_カテゴリ';
      case 'DispReplacementAreaBySearch':
        return '代替品エリア表示_検索結果';
      case 'DispReplacementAreaByVariation':
        return '代替品エリア表示_バリエーション一覧';
      default:
        /// eslint-disable-next-line no-console
        console.error('Invalid arguments');
        return '';
    }
  }
}
